var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t("menu.breadcrumb.home")))])],1),_vm._l((_vm.breadcrumb),function(item,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":item.link}},[_vm._v(_vm._s(item.title))])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }